import * as React from 'react';

import Input from 'components/inputs/input/Input';

interface Props {
  placeholder: string,
  channels: string,
  inputClassName?: string,
  onChange: (text: string) => void
}

interface State {
  text: string
}

class CreateNewProfilesEntitiesListRowTextArea extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { text: props.channels };
  }

  render() {
    const { placeholder, onChange, inputClassName } = this.props;
    const { text } = this.state;

    return (
      <Input
        multiline
        minMultilineHeight={34}
        width="responsive"
        value={text}
        placeholder={placeholder}
        className={inputClassName}
        onChange={event => this.setState({ text: event.currentTarget.value ?? '' })}
        onBlur={event => onChange(event.currentTarget.value ?? '')}
      />
    );
  }
}

export default CreateNewProfilesEntitiesListRowTextArea;
